import { ethers } from 'ethers';
import getNodeUrl from './getRpcUrl';

export const getProvider = () => {
  const nodeCall = getNodeUrl();
  return new ethers.providers.JsonRpcProvider(nodeCall);
};
